import { render, staticRenderFns } from "./SelectCollectionButtons.vue?vue&type=template&id=1f23b149&"
import script from "./SelectCollectionButtons.vue?vue&type=script&lang=js&"
export * from "./SelectCollectionButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports